import { create } from 'zustand';
import { NotificationModel } from './types';
export interface INotificationsState {
    anchorEl: null | HTMLElement,
    setAnchorEl: (val: null | HTMLElement) => void,

    showNoFacilityModal: boolean,
    setShowNoFacilityModal: (val: boolean) => void,

    take: number,
    setTake: (val: number) => void,

    hasFetched: boolean,
    setHasFetched: (val: boolean) => void,

    selectedNotifId: string,
    setSelectedNotifId: (selectedNotifId: string) => void,

}

const useNotificationsStore = create<INotificationsState>((set) => ({
    anchorEl: null,
    setAnchorEl: (anchorEl) => set({ anchorEl }),

    showNoFacilityModal: false,
    setShowNoFacilityModal: (showNoFacilityModal) => set({ showNoFacilityModal }),

    take: 10,
    setTake: (val: number) => set({take: val}),

    hasFetched: false,
    setHasFetched: (val: boolean) => set({hasFetched: val}),

    selectedNotifId: "",
    setSelectedNotifId: (selectedNotifId) => set({ selectedNotifId }),

}));

export default useNotificationsStore;